module.exports = {"countries":[{"name":"United States - FR","abbreviation":"USA - FR"},{"name":"Canada - FR","abbreviation":"CAN - FR"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/EventOptions/locales/fr.json
// module id = 1636
// module chunks = 0